import { useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Borradores de carga compartidos por área (kind: 'opi' | 'rem').
 * Un borrador no es un documento: no toma número, no espera aprobación y no mueve stock.
 * Hay uno por área y lo puede continuar cualquier compañero del área.
 */
export function useFormDraft(kind) {
  const [drafts, setDrafts] = useState([]);

  const loadDrafts = useCallback(async () => {
    try {
      const r = await axios.get(`${BACKEND_URL}/api/form-drafts/${kind}`, { withCredentials: true });
      setDrafts(r.data || []);
      return r.data || [];
    } catch {
      setDrafts([]);
      return [];
    }
  }, [kind]);

  const getDraft = useCallback(async (areaId) => {
    if (!areaId) return null;
    try {
      const r = await axios.get(`${BACKEND_URL}/api/form-drafts/${kind}/${areaId}`, { withCredentials: true });
      return r.data || null;
    } catch { return null; }
  }, [kind]);

  const saveDraft = useCallback(async (areaId, payload, { silent = false } = {}) => {
    if (!areaId) return null;
    try {
      const r = await axios.put(`${BACKEND_URL}/api/form-drafts/${kind}/${areaId}`, { payload }, { withCredentials: true });
      // El autoguardado silencioso NO refresca la lista de borradores (evita
      // re-render del banner y saltos de layout mientras el usuario escribe).
      if (!silent) setDrafts(prev => [r.data, ...prev.filter(d => d.area_id !== areaId)]);
      return r.data;
    } catch { return null; }
  }, [kind]);

  const deleteDraft = useCallback(async (areaId) => {
    if (!areaId) return;
    try {
      await axios.delete(`${BACKEND_URL}/api/form-drafts/${kind}/${areaId}`, { withCredentials: true });
    } catch { /* nada */ }
    setDrafts(prev => prev.filter(d => d.area_id !== areaId));
  }, [kind]);

  return { drafts, loadDrafts, getDraft, saveDraft, deleteDraft };
}
